"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _createSvg = require("../createSvg");
var _interfaces = require("../interfaces");
var _SVGIconWithSizes;
var _default = (0, _createSvg.createSvg)('IconShow', new _interfaces.SVGIconWithSizes((_SVGIconWithSizes = {}, (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.ExtraSmall, {
  paths: ['M8 10C9.10457 10 10 9.10457 10 8C10 6.89543 9.10457 6 8 6C6.89543 6 6 6.89543 6 8C6 9.10457 6.89543 10 8 10Z', 'M8.00012 3.00003C11.0807 2.98986 13.6259 5.57503 14.8716 7.76668C14.9539 7.91158 14.9539 8.08842 14.8716 8.23332C13.6259 10.425 11.0807 13.0101 8.00012 13C4.91958 13.0101 2.37438 10.425 1.12866 8.23332C1.0463 8.08842 1.0463 7.91158 1.12866 7.76668C2.37438 5.57503 4.91958 2.98986 8.00012 3.00003ZM11.0001 8C11.0001 9.65685 9.65698 11 8.00012 11C6.34327 11 5.00012 9.65685 5.00012 8C5.00012 6.34315 6.34327 5 8.00012 5C9.65698 5 11.0001 6.34315 11.0001 8Z'],
  params: {
    height: '16',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 16,
  width: 16
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Small, {
  paths: ['M10 12.5C11.3807 12.5 12.5 11.3807 12.5 10C12.5 8.61929 11.3807 7.5 10 7.5C8.61929 7.5 7.5 8.61929 7.5 10C7.5 11.3807 8.61929 12.5 10 12.5Z', 'M9.99981 4.00004C13.9471 3.98788 17.2107 7.06903 18.8182 9.69324C18.9338 9.88195 18.9338 10.118 18.8182 10.3068C17.2107 12.931 13.9471 16.0121 9.99981 16C6.05254 16.0121 2.78892 12.931 1.18143 10.3068C1.06583 10.118 1.06583 9.88195 1.18143 9.69324C2.78892 7.06903 6.05254 3.98788 9.99981 4.00004ZM13.9998 10C13.9998 12.2091 12.2089 14 9.99981 14C7.79067 14 5.99981 12.2091 5.99981 10C5.99981 7.79086 7.79067 6 9.99981 6C12.2089 6 13.9998 7.79086 13.9998 10Z'],
  params: {
    height: '20',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 20,
  width: 20
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Medium, {
  paths: ['M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z', 'M12.0001 4.50004C16.8316 4.48483 20.8251 8.34766 22.7868 11.6311C22.9228 11.8588 22.9228 12.1412 22.7868 12.3689C20.8251 15.6523 16.8316 19.5152 12.0001 19.5C7.16851 19.5152 3.17498 15.6523 1.21336 12.3689C1.07732 12.1412 1.07732 11.8588 1.21336 11.6311C3.17498 8.34766 7.16851 4.48483 12.0001 4.50004ZM17.0001 12C17.0001 14.7614 14.7615 17 12.0001 17C9.23864 17 7.00006 14.7614 7.00006 12C7.00006 9.23858 9.23864 7 12.0001 7C14.7615 7 17.0001 9.23858 17.0001 12Z'],
  params: {
    height: '24',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 24,
  width: 24
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Large, {
  paths: ['M16 20C18.2091 20 20 18.2091 20 16C20 13.7909 18.2091 12 16 12C13.7909 12 12 13.7909 12 16C12 18.2091 13.7909 20 16 20Z', 'M16.0001 6.00006C22.5789 5.9798 28.0183 11.1151 30.6974 15.4888C30.8901 15.8033 30.8901 16.1968 30.6974 16.5113C28.0183 20.885 22.5789 26.0203 16.0001 26C9.42127 26.0203 3.98186 20.885 1.3027 16.5113C1.11004 16.1968 1.11004 15.8033 1.3027 15.4888C3.98186 11.1151 9.42127 5.9798 16.0001 6.00006ZM23 16C23 19.866 19.866 23 16 23C12.134 23 9 19.866 9 16C9 12.134 12.134 9 16 9C19.866 9 23 12.134 23 16Z'],
  params: {
    height: '32',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 32,
  width: 32
}), _SVGIconWithSizes)));
exports.default = _default;